// Глобальные перехватчики НЕпойманных ошибок — сеть безопасности (слой 2).
//
// Зачем: ErrorBoundary ловит только ошибки рендера/жизненного цикла. Он НЕ
// ловит непойманные промисы (unhandledrejection) и ошибки из асинхронных
// колбэков — в т.ч. из WebSocket-обработчиков, которые в этом проекте без
// try/catch. Эти перехватчики логируют такие ошибки, чтобы они не пропадали
// молча.
//
// КРИТИЧНО: здесь НЕТ показа UI-уведомлений. Ошибки API-запросов уже
// показываются пользователю через thunkHandlers.error (setModalMessage /
// setMessage). Если показывать ещё и отсюда — будет задвоение. Этот модуль
// только логирует (console.error) — единственный механизм репортинга в
// проекте сейчас. Появится отправка на бэк — добавлять в reportError.

const reportError = (label: string, detail: unknown) => {
    // eslint-disable-next-line no-console
    console.error(`[GlobalErrorHandler] ${label}:`, detail);
};

export const setupGlobalErrorHandlers = () => {
    // Непойманные отклонённые промисы (async/await без catch, .then без .catch,
    // ошибки в промис-цепочках WS/таймеров).
    window.addEventListener("unhandledrejection", (event: PromiseRejectionEvent) => {
        reportError("unhandledrejection", event.reason);
    });

    // Прочие непойманные ошибки: синхронные исключения вне React-рендера,
    // ошибки в обработчиках событий и асинхронных колбэках (включая WS).
    window.addEventListener("error", (event: ErrorEvent) => {
        reportError("uncaught error", event.error ?? event.message);
    });
};
